import oxenFlowHorizontal from '../../assets/oxenflow-letter-only-white@3x copy.png';
import {
  APP_STORE_URL,
  AUREUS_OX_URL,
  TUTORIALS_URL
} from '../../constants/links';

const AUREUS = {
  green: '#6FC2AE',
  blue: '#609EBD',
  navy: '#01263D',
  purple: '#4643D3'
};

const Header = () => {
  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 border-b backdrop-blur-xl"
      style={{
        background: 'rgba(1, 38, 61, 0.75)',
        borderColor: 'rgba(111, 194, 174, 0.15)'
      }}
    >
      <nav className="mx-auto max-w-7xl px-6 py-4 md:py-5 flex items-center justify-between">
        <div className="flex flex-col gap-0.5">
          <a href="/" className="flex items-center">
            <img
              src={oxenFlowHorizontal}
              alt="Oxen Flow"
              className="w-36 md:w-40"
            />
          </a>
          <a
            href={AUREUS_OX_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="hidden md:inline-block text-[11px] tracking-wide opacity-70 hover:opacity-100 transition-opacity pl-0.5"
            style={{ color: AUREUS.blue }}
          >
            by{' '}
            <span className="font-medium" style={{ color: AUREUS.green }}>
              Aureus Ox
            </span>
          </a>
        </div>

        <div className="flex items-center gap-4 md:gap-6 lg:gap-7">
          <a
            href="/#features"
            className="hidden md:flex text-gray-300 hover:text-white transition-colors"
          >
            Features
          </a>

          <a
            href="/#how-it-works"
            className="hidden md:flex text-gray-300 hover:text-white transition-colors"
          >
            How it works
          </a>

          <a
            href="/#security"
            className="hidden lg:flex text-gray-300 hover:text-white transition-colors"
          >
            Security
          </a>

          <a
            href="/support"
            className="hidden md:flex text-gray-300 hover:text-white transition-colors"
          >
            FAQ
          </a>

          <a
            href={TUTORIALS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="hidden lg:flex text-gray-300 hover:text-white transition-colors"
          >
            Tutorials
          </a>

          <a
            href={AUREUS_OX_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="hidden xl:flex text-sm text-gray-400 hover:text-white transition-colors"
          >
            Aureus Ox
          </a>

          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="px-5 md:px-7 py-2.5 rounded-xl font-medium transition-all shadow-lg inline-flex items-center"
            style={{
              background: AUREUS.green,
              color: '#01263D',
              boxShadow: `0 8px 25px rgba(111, 194, 174, 0.35)`
            }}
          >
            Download
          </a>
        </div>
      </nav>
    </header>
  );
};

export default Header;
